import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

const normalizeQuestionTabs = (tabList = []) => {
	return tabList.filter(item => item?.isPublish).sort((a, b) => a.sort - b.sort);
};

export const useQuestionConfigData = () => {
	const { config, loadModuleConfig } = useModuleConfig();

	const loadQuestionTabs = async () => {
		await loadModuleConfig('question');
		return normalizeQuestionTabs(config.value?.tab || []);
	};

	const resolveOverviewSourceBizList = tabs => {
		const tabMap = Array.isArray(tabs) ? tabs : [];
		const hasAll = tabMap.some(item => item?.id === 'question_all');
		if (hasAll) return [];
		return tabMap.map(item => item?.value);
	};

	return {
		config,
		loadQuestionTabs,
		resolveOverviewSourceBizList
	};
};
